import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import type { RegistrationStammdatenPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';

// ===== Community of Practice: Generative KI =====

export const cpgRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::cpg',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new CPGStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(CPGStammdaten.fields).filter(it => !['_id', '_class', 'userID', 'institutionID'].includes(it));
  },
  classType: () => CPGStammdaten,
};

export enum CPGFachbereichEnum {
  CPG_FB1 = 'CPG_FB1',
  CPG_FB2 = 'CPG_FB2',
  CPG_FB3 = 'CPG_FB3',
  CPG_FB4 = 'CPG_FB4',
  CPG_FB5 = 'CPG_FB5',
  CPG_FB6 = 'CPG_FB6',
  CPG_FB7 = 'CPG_FB7',
  CPG_FB8 = 'CPG_FB8',
  CPG_FB9 = 'CPG_FB9',
  CPG_FB10 = 'CPG_FB10',
  CPG_FB11 = 'CPG_FB11',
  CPG_FB12 = 'CPG_FB12',
  CPG_FB13 = 'CPG_FB13',
  CPG_FB14 = 'CPG_FB14',
  CPG_FB15 = 'CPG_FB15',
  CPG_FB16 = 'CPG_FB16',
  CPG_SONSTIGES = 'CPG_SONSTIGES',
}
registerEnum({ enum: CPGFachbereichEnum, name: 'CPGFachbereichEnum' });

@Entity()
export class CPGStammdaten extends UserStammdaten {
  static override _class = 'CPGStammdaten';

  override getTranslationNamespace() {
    return 'cpg';
  }

  @Field(type => String)
  welchemFachbereichGehrstDuAn: Maybe<CPGFachbereichEnum>;

  @Field(type => String)
  bitteGibAnVonWelcherEinrichtungAbteilungDuKommst: Maybe<string>;

  @Field(type => String)
  warumMchtestDuTeilDerCommunitySeinWelcheBedarfeHastDu: Maybe<string>;

  @Field(type => String)
  wasKnntestDuZurCommunityBeitragenWieMchtestDuDichEinbringen: Maybe<string>;
}
